import { COMMON, ifyouApi, STORY } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

/**
 * 작품 관리 - 미션 Api 모음
 */

export const missionApis = {
  read: (projectId, lang) =>
    ifyouApi
      .post(`${STORY}/${projectId}/mission-project-list`, { lang: lang })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  register: (projectId, formData) =>
    ifyouApi
      .post(`${STORY}/${projectId}/mission-project-insert`, formData, {
        header: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detail: (projectId, missionId, lang) =>
    ifyouApi
      .post(`${STORY}/${projectId}/mission-project-detail`, {
        lang: lang, //? 언어 안보내도 되는거 같은데? 22.6.24.sjy
        mission_id: missionId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (projectId, formData) =>
    ifyouApi
      .post(`${STORY}/${projectId}/mission-project-update`, formData, {
        header: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  delete: (projectId, missionId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/mission-project-delete`, {
        mission_id: missionId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

export const fetchDropdownDataList = {
  currencyList: () =>
    ifyouApi
      .post(`${COMMON}`, { func: 'adminMissionCurrencyList' })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  episodeList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, { func: 'adminEpisodeList', project_id: projectId })
      .then((res) => res.data),
  sceneList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, { func: 'adminSceneList', project_id: projectId })
      .then((res) => {
        let newData = [];
        res.data?.map((v, i) =>
          newData.push({ key: i, text: v.scene_text, value: v.scene_id }),
        );
        return newData;
      })
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
